import React from 'react'
import { Container, Row } from 'react-bootstrap'
import IntroSect from '../compCards/IntroSect'

const POSSystemIntro = () => {
  return (
    <div className="intro" style={{}}>
      <Container
        fluid
        style={{
          textAlign: 'center',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '60px 20px',
          height: '100%'
        }}
      >
        <div className="intro-overlay"></div>
        <Row style={{ zIndex: '2' }}>
          <IntroSect head1="SMG POS System" head2="POS System" />
        </Row>
      </Container>
    </div>
  )
}

export default POSSystemIntro
